import type { ReactNode } from 'react';
import { memo, Fragment } from 'react';
import { FormattedMessage } from 'react-intl';
import { Tooltip, Text } from '@library';
import type { ProductBackorder } from '../../queries/useProductBackorders';
import formatBackorder from '../../util/formatBackorders';
import styles from './ProductBackorderTooltip.module.scss';

interface ProductBackorderTooltipProps {
    children: ReactNode;
    backorders: ProductBackorder[];
}

const ProductBackorderTooltip = ({
    children,
    backorders,
}: ProductBackorderTooltipProps) => {
    const productBackorders = formatBackorder(backorders);
    return (
        <Tooltip
            placement="top"
            content={
                <div
                    className={styles.items}
                    data-test-class="backorderTooltipContent"
                >
                    {productBackorders.map((item, idx) => (
                        <Fragment key={idx}>
                            <Text secondary medium>
                                <FormattedMessage
                                    id={item.message}
                                    values={item.values}
                                />
                            </Text>
                            <div className={styles.separator} />
                        </Fragment>
                    ))}
                </div>
            }
            showArrow
            theme={styles.theme}
        >
            <div className={styles.trigger} data-test-class="backorderTooltip">
                {children}
            </div>
        </Tooltip>
    );
};

export default memo(ProductBackorderTooltip);
